import { csHttp } from "./http";

export const csRegister = (payload) =>
  csHttp.post("/api/auth/register", payload).then(r => r.data);

export const csLogin = (payload) =>
  csHttp.post("/api/auth/login", payload).then(r => r.data);

export const csByPhone = (phone) =>
  csHttp.get("/api/auth/by-phone", { params: { phone } }).then(r => r.data);
